<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Delete note</p>
      </header>
      <section class="modal-card-body">
        <p>
          Are you sure you want to delete note?
        </p>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="deleteError">
          {{ deleteError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancelModal" :disabled="isDeleting">Cancel</button>
            <button
              class="button is-danger"
              @click="confirmDeleteNote"
              :class="{ 'is-loading': isDeleting }"
              :disabled="isDeleting"
            >
              Delete
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { DELETE_NOTE } from './userStore'

export default {
  name: 'UserDeleteNoteModal',

  props: {
    userStorePath: {
      type: String,
      required: true
    },

    note: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isDeleting: false,
      deleteError: null
    }
  },

  methods: {
    cancelModal() {
      this.$emit('cancelled')
    },

    async confirmDeleteNote() {
      const userNoteId = this.note.id

      this.isDeleting = true
      this.deleteError = null

      try {
        const deleteNoteAction = `${this.userStorePath}/${DELETE_NOTE}`
        await this.$store.dispatch(deleteNoteAction, { userNoteId })

        this.$emit('succeeded')
      } catch (error) {
        this.deleteError = error || 'Something went wrong.'
      } finally {
        this.isDeleting = false
      }
    }
  },

  computed: {
    showModal() {
      return this.note !== null
    }
  }
}
</script>

<style></style>
